import React, { useEffect, useState } from "react"
import Banner from "../containers/banner"
import About from "../containers/about"
import Skills from "../containers/skills"
import Project from "../containers/project"
import Layout from "../containers/layout";
import { Container, Row, Col } from 'reactstrap';
import { Subtitle, Description, Title, Titlespan2 } from '../components/title/index';

const IndexPage = () => {
    return (
        <Layout>
            <Banner ChangeClass={'demo1'} title="Who We Are" body="NGT Transformation Services is made up of the best profressionals in the telecommunications industry."/>
            <Skills />
            <About title={'Our Perspective'} body={`The traditional core businesses of telecom operators and communications equipment suppliers are under pressure. We have the expertise—and a global network of senior telco and digital consultants with deep telecommunications experience—to help companies address the industry's most critical issues like dealing with uncertainty, decision making, building competitive advantage, capitalising on data surge and delighting the customer profitably with simplified and relevant customer propositions and innovations.`} />

            <section className="blog-wrapper" id="blog">
                <Container>
                    <div className="main-title-wrapper">
                        <Subtitle
                            Class="site-subtitle"
                            Name="How we think"
                        />
                        <Titlespan2
                            Class="sitemain-subtitle"
                            Name="Our Mission and belief"
                            Label=""
                        />

                        <Description
                            Class="site-dec"
                            Name="We believe that bold steps define the future. That the ambition to lead requires the courage to adapt. And that doing the right thing is rarely easy, but always worth it."
                        />
                        <br/>
                        <Description
                            Class="site-dec"
                            Name="We seek out people and clients who challenge themselves to be exceptional—and champion that spirit in others. We’re guided by our knowledge and customer needs, our unwavering commitment to always do the right thing by our clients, people and communities."
                        />
                    </div>
                </Container>
            </section>
            
            <Project />
        </Layout>
    )
}

export default IndexPage
